<div class="Nav h-f pos-a pos-s@s">
  <div *ngIf="currentStep<=stepCount" class="Nav-container pos-a" [ngStyle]="{'transform': 'translateX(-50%)'}">
    <div class="Nav-progress h-f pos-a" [ngStyle]="{'width':(currentStep-1)*100/(stepCount-1) + '%'}"></div>
    <div class="Nav-dots">
      <div class="g g--spaceBetween">
        <div *ngFor="let step of stepArray">
          <div class="NavDot pos-r"
            [ngClass]="{'is-active' : currentStep===(step+1), 'is-finished' : currentStep>step}">
            <div class="NavDot-t c-s fz-26 pos-a pos--centerx">
              <span *ngIf="currentStep===(step+1)"><span>{{currentStep}}</span><span
                  class="fz-18 c-white">/{{stepCount}}</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
